import React from 'react'
import { createRoot } from 'react-dom/client'
import ConsultationFormModal from '../components/TeamPublicPage/ConsultationFormModal'

// Join Teams page - login modal for guests + consultation modal
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('join-teams-container')
  if (!container) return

  // Clean consultation_sent param from URL after showing banner
  const params = new URLSearchParams(window.location.search)
  if (params.get('consultation_sent') === '1') {
    params.delete('consultation_sent')
    const remaining = params.toString()
    window.history.replaceState({}, '', window.location.pathname + (remaining ? `?${remaining}` : ''))
  }

  // Consultation Modal (React)
  const consultationTeams = JSON.parse(container.dataset.consultationTeams || '{}')
  const currentUser = JSON.parse(container.dataset.currentUser || 'null')
  const consultationTranslations = JSON.parse(container.dataset.consultationTranslations || '{}')
  let consultationRoot = null

  function renderConsultationModal(teamId, isOpen) {
    const modalContainer = document.getElementById('consultation-modal-root')
    if (!modalContainer) return
    if (!consultationRoot) {
      consultationRoot = createRoot(modalContainer)
    }
    const teamData = consultationTeams[teamId] || {}
    consultationRoot.render(
      React.createElement(ConsultationFormModal, {
        isOpen,
        onClose: () => renderConsultationModal(teamId, false),
        onSubmitted: (_result, { hasBooking } = {}) => {
          renderConsultationModal(teamId, false)
          showConsultationSuccess(hasBooking)
        },
        teamId: parseInt(teamId, 10),
        teamSlug: teamData.slug || '',
        fields: teamData.intakeFormFields || [],
        colors: { primary: '#3366FF' },
        currentUser,
        translations: consultationTranslations,
        consultationEnabled: teamData.consultationEnabled || false,
        consultationDuration: teamData.consultationDuration || 30,
        userTimezone: currentUser?.timezone,
        previousResponses: null,
        mode: 'join'
      })
    )
  }

  window.openConsultationModal = function (teamId) {
    if (!currentUser) {
      window.location.href = `/users/sign_in?redirect_to=${encodeURIComponent(window.location.href)}`
      return
    }
    renderConsultationModal(teamId, true)
  }

  function showConsultationSuccess(hasBooking) {
    const ct = consultationTranslations?.consultation || {}
    const successText = hasBooking
      ? (ct.join_success || '預約諮詢成功！記得準時出席')
      : (ct.join_success_no_booking || '已送出！團長收到通知後會回覆你')
    let banner = document.getElementById('consultation-success-banner')
    if (!banner) {
      banner = document.createElement('div')
      banner.id = 'consultation-success-banner'
      banner.className = 'mb-6 bg-green-50 border border-green-200 rounded-xl px-5 py-4 flex items-center gap-3'
      const content = container.querySelector('.max-w-4xl')
      if (content) {
        content.insertBefore(banner, content.firstChild)
      }
    }
    banner.innerHTML = `
      <svg class="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span class="text-green-800 font-medium">${successText}</span>
    `
    banner.classList.remove('hidden')
    banner.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  // Login modal for guests
  const loginModal = document.getElementById('login-modal')
  if (loginModal) {
    const modalTitle = document.getElementById('login-modal-title')
    const modalSlug = document.getElementById('login-modal-slug')

    window.showLoginModal = (teamName, slug) => {
      modalTitle.textContent = `Apply to Join ${teamName}` // TODO: i18n
      modalSlug.value = slug
      loginModal.classList.remove('hidden')
    }

    window.closeLoginModal = () => {
      loginModal.classList.add('hidden')
    }

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !loginModal.classList.contains('hidden')) {
        closeLoginModal()
      }
    })
  }
})
